class BoxReadmore {

    constructor(element) {
        console.log('BoxReadmore.constructor 1', element);
        this.element = element;
        this.buttonReadmore = this.element.getElementsByClassName('button-readmore')[0];
        this.buttonClose = this.element.getElementsByClassName('button-close')[0];
        this.buttonReadmore.addEventListener('click', this.onClick.bind(this));
        this.buttonClose.addEventListener('click', this.onClick.bind(this));
    }

    destroy() {
        console.log('BoxReadmore.destroy', this.element);
        this.buttonReadmore.removeEventListener('click', this.onClick.bind(this));
        this.buttonClose.removeEventListener('click', this.onClick.bind(this));
    }

    onClick() {
        console.log('BoxReadmore.onClick', this.element);
        this.element.classList.toggle('selected');
    }
}

BoxReadmore.elementClassName = 'box-readmore-base';
BoxReadmore.instances = [];
BoxReadmore.init = function () {
    console.log('BoxReadmore.init');
    var elements = document.getElementsByClassName(BoxReadmore.elementClassName);
    for (const element of Array.from(elements)) {
        BoxReadmore.instances.push(new BoxReadmore(element));
    }
    console.log('BoxReadmore.instances.length', BoxReadmore.instances.length);
};

BoxReadmore.onDispose = function () {
    console.log('BoxReadmore.onDispose');
    while (BoxReadmore.instances.length) {
        console.log('BoxReadmore.instances.length', BoxReadmore.instances.length);
        let instance = BoxReadmore.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default BoxReadmore;

if (module.hot) {
    module.hot.dispose(BoxReadmore.onDispose);
}
